<template>
  <transition name="rightWebsocket">
    <div
      v-if="showWebsocket"
      class="websocketBox flex_col_s font-color-white"
      ref="websocketBox"
    >
      <div class="w-100 flex_row_s relative margin-bottom-20">
        <div
          class="w-100 text-align-center font-weight-bold font-color-name letter-spacing overflowY-auto"
        >
          事件通知
        </div>
        <i
          class="el-icon-close close absolute font-weight-bold font-color-white pointer"
          @click="handleClose"
        ></i>
      </div>
      <div class="w-100 flex-1 flex_col_s">{{ eventData?.message }}</div>
      <div class="flex_row_c margin-top-20">
        <div class="handleBtn font-size-12 pointer" @click="goJump">去查看</div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      showWebsocket: false,
      eventData: {},
    };
  },
  created() {
    window.addEventListener('setItem', () => {
      if (sessionStorage.getItem('websocketInform')) {
        this.eventData = JSON.parse(sessionStorage.getItem('websocketInform'));
        this.showWebsocket = true;
      } else {
        this.showWebsocket = false;
      }
    });
  },
  methods: {
    handleClose() {
      sessionStorage.removeItem('websocketInform');
      this.showWebsocket = false;
    },

    goJump() {
      if (this.$route.path !== '/screen/simulationRegulation') {
        this.$router.push('/screen/simulationRegulation');
      }
      this.handleClose();
    },
  },
};
</script>
<style lang="scss" scoped>
.websocketBox {
  position: fixed;
  z-index: 99999;
  right: 1rem;
  top: 1rem;
  width: 20rem;
  height: 15rem;
  background: url('@/assets/images/websocketBox.png') no-repeat;
  background-size: 100% 100%;
  box-shadow: 0 0 2rem rgba(0, 0, 0, 0.3);
  padding: 1rem 1rem 1.5rem 1rem;
  transition: 0.2s;
  .close {
    right: 0;
  }
  .each {
    background: url('@/assets/images/blue_each.png') no-repeat;
    background-size: 100% 100%;
  }
  .handleBtn {
    background: url('@/assets/images/blue_btn.png') no-repeat;
    background-size: 100% 100%;
    padding: 0.3rem 1rem;
  }
}

.rightWebsocket-enter,
.rightWebsocket-leave-to {
  // transform: translateX(-55vw);
  transform: translateX(20rem) translateY(0) scale(0);
  // transform: skew(20px);
}

.rightWebsocket-enter-active,
.rightWebsocket-leave-active {
  transition: 0.3s;
  transition-timing-function: ease-in-out;
}

.rightWebsocket-enter-to,
.rightWebsocket-leave {
  // transform: translateX(0vw);
  transform: translateX(0) translateY(0) scale(1);
}
::v-deep .el-input--medium .el-input__inner {
  height: 2rem !important;
  line-height: 2rem !important;
}
</style>
